import * as React from "react";
import PipelineLogEdit from "./PipelineLogEdit";
import { pipelineobj } from "../../Entity/SSOObj";
import "./pipeline.scss";
//import Moment from "react-moment";
import { Helper } from "../../Utils/Helper";
import {
  DirectionalHint,
  IContextualMenuItem
} from "office-ui-fabric-react/lib/ContextualMenu";

import MIPADatePicker from "../Common/datepicker";
import MIPAChoiceAction from "../Common/ChoiceAction";
import ContactDetailView from "../ContactDetailView/ContactDetailView";
import CRMEditFrom from "../Common/CRMEditFrom";

export interface IProps {
  data: pipelineobj;
  Probability;
  Phases;
  UpdateMethod;
  LogTitle;
  InsideCRM;
  CRMURL;
  Phrases;
  contactlinks;
  RefreshCRMData;
}

export interface IContextualMenuState {
  directionalHint?: DirectionalHint;
  directionalHintForRTL?: DirectionalHint;
  useDirectionalHintForRtl?: boolean;
  isBeakVisible?: boolean;
  gapSpace?: number;
  beakWidth?: number;
  edgeFixed?: boolean;
  isCalloutVisible?: boolean;
  SalesLog: string;
  ShowEditWindow?: boolean;
}

export default class CRMSSOCom extends React.Component<
  IProps,
  IContextualMenuState,
  IContextualMenuItem
> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isCalloutVisible: false,
      directionalHint: DirectionalHint.topCenter,
      beakWidth: 16,
      SalesLog: props.data.SalesLog,
      ShowEditWindow:false
    };
  }
  public handleLogChange = (event): void => {
    this.setState({ SalesLog: event.target.value });
  };

  public AddSummary = event => {
    let summarytext = this.state.SalesLog;
    if (summarytext == "") {
      summarytext = this.props.LogTitle;
    } else {
      summarytext = this.props.LogTitle + "\n\n" + summarytext;
    }
    this.setState({ SalesLog: summarytext });
  };
  public render() {
    let followupData = this.props.data.Followup;
    let exptcloser = this.props.data.ExpectedCloser;
    let probabilitystyle = {
      backgroundSize: this.props.data.Probability + " 100%"
    };
    let rowcss = "ms-Grid-row miparow";
    let webpartbody =
      this.props.data.SSOColmn < 0
        ? ["webpartbody", "overdue"].join(" ")
        : "webpartbody";
    let editlink;
    if(!window.IsMobileOperatingSystem()){
      if (this.props.InsideCRM) {
      editlink = (
        <a
          title={this.props.Phrases.edit}
          className="editlink"
          onClick={() => {
            window.parent.postMessage(
              { action: "edit", data: { type: "sso", id: this.props.data.ID } },
              "*"
            );
          }}
        >
          <i className="ms-Icon ms-Icon--EditSolid12" />
        </a>
      );
    } else {
      
        
/* let link =window.GetCRMTeamsDeepLink(this.props.data.ID,'dashboard',0,
  "OpenEntryForm('sso', 'dashboard'," +this.props.data.ID +", '')"); 
      editlink = (
        <a
          title={this.props.Phrases.edit}
          className="editlink"
          href="#"
          onClick={()=>{window.NavigateToTeamTab(link)} }
        >
          <i className="ms-Icon ms-Icon--WindowEdit" />
        </a>
      ); */
      
      const host = window["teamcontext"]?.host;

      if (host != null && host != undefined && host.toLowerCase().indexOf("teams") >= 0) {
        editlink = (
              <a
                title={this.props.Phrases.edit}
                className="editlink"
                href="#"    
                onClick={(e)=>{this.OpenEditWindow(e);} }     
              >
                <i className="ms-Icon ms-Icon--WindowEdit" />
              </a>
            );
      }else{
        editlink = (
        <a
          title={this.props.Phrases.edit}
          className="editlink"
          href="#"    
          onClick={(e)=>{e.preventDefault();e.stopPropagation(); this.setState({ ShowEditWindow: true });} }     
        >
          <i className="ms-Icon ms-Icon--WindowEdit" />
        </a>
      );
      }
      
     
    }
    }
    
    return (
      <>
        <div className="webpart">
        <div className="webpartTitle">
          <span>{this.props.Phrases.title}</span>
          {editlink}
          <PipelineLogEdit
            data={this.props.data}
            SaveText={this.props.Phrases.savelog}
            UpdateMethod={this.props.UpdateMethod}
            LogTitle={this.props.LogTitle}
          />
        </div>
        <div className={webpartbody}>
          <div className="ms-Grid">
            {this.prepareCustomData(rowcss)}
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm6">
                <div title={this.props.data.ProductName} className="ellips">
                  {this.props.data.ProductName}
                </div>
              </div>
              <div className="ms-Grid-col ms-sm6">
                <MIPAChoiceAction
                  key={this.props.data.ID + "_Phase"}
                  contextbuttoncss="contextbutton"
                  items={this.PreparePhaseItems()}
                >
                  <div
                    title={this.props.data.Phase}
                    className={["phase", "ellips"].join(" ")}
                  >
                    {this.props.data.Phase}
                  </div>
                </MIPAChoiceAction>
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm6">
                <div
                  className="dateleft"
                  title={this.props.Phrases.setfollowupdate}
                >
                  <MIPADatePicker
                    datevalue={followupData}
                    ChangeDate={date => {
                      this.UpdateSSOValue(
                        this.props.data.ID,
                        date,
                        "IGlobeCRM_SSO_Followup",
                        "DateTime",
                        this.props.data.SSOColmn
                      );
                    }}
                  />
                </div>
              </div>
              <div
                className="ms-Grid-col ms-sm6"
                title={this.props.Phrases.expectedclouser}
              >
                {/* <Moment className="dateright" format="DD MMM YY">
                  {exptcloser}
                </Moment> */}
                 <div
                  className="dateright"
                >
                  <MIPADatePicker
                    datevalue={exptcloser}
                    ChangeDate={date => {
                      this.UpdateSSOValue(
                        this.props.data.ID,
                        date,
                        "IGlobeCRM_SSO_ExpectedCloser",
                        "DateTime",
                        this.props.data.SSOColmn
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <ContactDetailView
                  contactName={this.props.data.ContactName}
                  contactId={this.props.data.ContactId}
                  contactlinks={this.props.contactlinks}
                  crmurl={this.props.CRMURL}
                />
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <div
                  title={this.props.data.CompanyName}
                  className={["company", "ellips"].join(" ")}
                >
                  {this.props.data.CompanyName}
                </div>
              </div>
            </div>
            <div className={rowcss}>
              <div
                className="ms-Grid-col ms-sm6"
                title={this.props.Phrases.potential}
              >
                {Helper.GetCurrencyFormat(
                  this.props.data.Potential,
                  this.props.data.CurrencyLocal,
                  this.props.data.DecimalSeperator,
                  this.props.data.ThousandSeperator
                )}
              </div>
              <div className="ms-Grid-col ms-sm6">
                <MIPAChoiceAction
                  key={this.props.data.ID + "_progress"}
                  contextbuttoncss="contextbutton"
                  items={this.PrepareProbabilityItems()}
                >
                  <div
                    title={this.props.Phrases.probability}
                    style={probabilitystyle}
                    className="ssoProgress"
                  >
                    {this.props.data.Probability}
                  </div>
                </MIPAChoiceAction>
              </div>
            </div>
          </div>
        </div>
      </div>
      {this.state.ShowEditWindow && (
              <CRMEditFrom onClose={(result) => {
                if(result.entity==='sso' && result.id.toString()===this.props.data.ID.toString()){
                  if(result.updated){
                    this.props.RefreshCRMData(this.props.data.SSOColmn,'SSO');
                  }
                  this.setState({ ShowEditWindow: false });
                }
                
              }}
               itemid={"sso_"+this.props.data.ID}
              URL={this.GetSSOEditLink(this.props.data.ID)}>
              </CRMEditFrom>
              
            )}
      </>
    );
  }
  public prepareCustomData = rowcss => {
    let data = [];
    this.props.data.Customs.map((customitem, index) => {
      data.push(
        <div key={"Custom_" + index} className={rowcss}>
          <div className="ms-Grid-col ms-sm12">
            <div title={customitem.spvalue} className="ellips">
              {customitem.spvalue}
            </div>
          </div>
        </div>
      );
    });
    return data;
  };
  public PrepareProbabilityItems(): IContextualMenuItem[] {
    let menus = [];
    let keyIndex = 0;
    this.props.Probability.forEach(element => {
      let menu = {
        key: "Probability_" + keyIndex,
        name: element,
        iconProps: {
          className:
            this.props.data.Probability == element
              ? "ms-Icon ms-Icon--RadioBtnOn"
              : "ms-Icon ms-Icon--RadioBtnOff"
        },
        onClick: event => {
          //this.setState({ showCallout: true });
          this.UpdateSSOValue(
            this.props.data.ID,
            element,
            "IGlobeCRM_SSO_Probability",
            "Choice",
            this.props.data.SSOColmn
          );
        }
      };
      keyIndex++;
      menus.push(menu);
    });
    return menus;
  }
  public PreparePhaseItems(): IContextualMenuItem[] {
    let menus = [];
    let keyIndex = 0;
    this.props.Phases.forEach(element => {
      let menu = {
        key: "SSOPhase_" + keyIndex,
        name: element,
        iconProps: {
          className:
            this.props.data.Phase == element
              ? "ms-Icon ms-Icon--RadioBtnOn"
              : "ms-Icon ms-Icon--RadioBtnOff"
        },
        onClick: () => {
          this.UpdateSSOValue(
            this.props.data.ID,
            element,
            "IGlobeCRM_SSO_Pipeline",
            "Choice",
            this.props.data.SSOColmn
          );
        }
      };
      keyIndex++;
      menus.push(menu);
    });
    return menus;
  }

  public UpdateSSOValue = (itemId, newValue, propName, type, col) => {
    let SSOObj = {
      listtitle: "SSO List",
      ID: itemId,
      fieldslist: [
        {
          spfieldname: propName,
          spvalue: newValue,
          spfieldtype: type
        }
      ]
    };
    if (propName == "IGlobeCRM_SSO_Pipeline") {
      SSOObj.fieldslist.push({
        spfieldname: "IGlobeCRM_SSO_Phase_No",
        spvalue: this.props.Phases.indexOf(newValue),
        spfieldtype: "Number"
      });
    }

    this.props.UpdateMethod(SSOObj, col, true);
  };
  public OpenEditWindow= (e): void => {
      //let url=`https://${window.location.host}/crmteam/entityview?id=${this.props.data.ID}&entity=sso&page=pipeline&action=edit`;
      let url=this.GetSSOEditLink(this.props.data.ID);
      Helper.OpenCRMEditWindow(e,url,(data)=>{
         if(data.result["saved"]){
            this.props.RefreshCRMData(this.props.data.SSOColmn,'SSO');
          }
      });
    };
    public GetSSOEditLink = (id) => {
      let url=`https://${window.location.host}/crmteam/entityview?id=${id}&entity=sso&page=pipeline&action=edit`;
      return url;
    }
  /*private _onCalloutDismiss = (): void => {
    this.setState({
      isCalloutVisible: false
    });
  }

  private _onShowMenuClicked = (): void => {
    this.setState({
      isCalloutVisible: !this.state.isCalloutVisible
    });
  }*/
}
